module.exports = __webpack_public_path__ + "images/ec53ca1be4c2ab81458c584a520e6e72.svg";